import React from 'react';
import Input from '../../Input';
export default function Number(props) {
    return <Input {...props}></Input>;
}
